import { render, staticRenderFns } from "./GoDocumentsButton.vue?vue&type=template&id=4c795cf3"
import script from "./GoDocumentsButton.vue?vue&type=script&lang=js"
export * from "./GoDocumentsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports